import { FETCH_PUBLIC_KEY_SUCCESS } from 'constants/ui';

type PublicKeyAction = {
  type: typeof FETCH_PUBLIC_KEY_SUCCESS;
  payload: {
    publicKey: string;
  };
};

const publicKey = (state = '', action: PublicKeyAction) => {
  switch (action.type) {
    case FETCH_PUBLIC_KEY_SUCCESS:
      return action.payload.publicKey;
    default:
      return state;
  }
};

export { publicKey };
